import { api } from '@/api/core';
import { TEAMS_LIST_TAG } from '@/api/constants';

export type TeamListItem = {
  teamId: string;
  name: string;
  departmentId?: string;
};

export type TeamsListResponse = {
  teams: TeamListItem[];
};

const teamsListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTeamsList: builder.query<TeamsListResponse, void>({
      query: () => ({
        url: `teams/list`,
        method: 'GET',
      }),
      providesTags: () => [{ type: TEAMS_LIST_TAG }],
    }),
  }),
});

export const { useGetTeamsListQuery } = teamsListApi;
